import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { useUser } from '../../contexts/UserContext';
import { canAccessResource, getResourceBySlug } from '../../content/resources/catalog';
import styles from './Resources.module.css';

export const ResourceArticlePage: React.FC = () => {
  const { slug = '' } = useParams<{ slug: string }>();
  const { isAuthenticated } = useUser();
  const item = getResourceBySlug(slug);

  if (!item) {
    return (
      <main className={styles.page} data-testid="resource-not-found">
        <p>Resource not found.</p>
        <Link to="/resources">Back to Resources</Link>
      </main>
    );
  }

  if (!canAccessResource(item, isAuthenticated)) {
    return <Navigate to={`/login?next=${encodeURIComponent(`/resources/${item.slug}`)}`} replace />;
  }

  if (item.htmlPath || item.htmlBody) {
    return (
      <main className={styles.htmlHost} data-testid="resource-article-html">
        <div className={styles.htmlChrome}>
          <Link to="/resources" className={styles.back}>
            ← Resources
          </Link>
          {item.htmlPath ? (
            <a className={styles.openFull} href={item.htmlPath} target="_blank" rel="noreferrer">
              Open full page
            </a>
          ) : null}
        </div>
        <iframe
          className={styles.htmlFrameFull}
          title={item.title}
          src={item.htmlPath}
          srcDoc={item.htmlPath ? undefined : item.htmlBody}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      </main>
    );
  }

  return (
    <main className={styles.page} data-testid="resource-article">
      <p className={styles.eyebrow}>
        <Link to="/resources" className={styles.back}>
          Resources
        </Link>
      </p>
      <h1 className={styles.title}>{item.title}</h1>
      <p className={styles.lede}>{item.summary}</p>

      {item.bodyMarkdown ? (
        <article className={styles.body}>
          <ReactMarkdown>{item.bodyMarkdown}</ReactMarkdown>
        </article>
      ) : null}
    </main>
  );
};
